// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.performancepg-inline-1 {
  text-align: center;
  padding: 60px;
}

.performancepg-inline-2 {
  margin: 0 auto 20px;
}

.performancepg-inline-3 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.performancepg-inline-4 {
  margin-bottom: 16px;
}

.performancepg-inline-5 {
  padding: 0;
  overflow-x: auto;
}

.performancepg-inline-6 {
  font-family: monospace;
  font-size: 11px;
}

.performancepg-inline-7 {
  font-weight: 600;
}

.performancepg-inline-8 {
  font-size: 11px;
}

.performancepg-inline-9 {
  font-size: 11px;
}

.performancepg-inline-10 {
  display: flex;
  align-items: center;
  gap: 6px;
}

.performancepg-inline-11 {
  font-size: 11px;
}

.performancepg-inline-12 {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.performancepg-inline-13 {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 16px;
}

.performancepg-inline-14 {
  overflow-x: auto;
}

.performancepg-inline-15 {
  font-weight: 600;
}

.performancepg-inline-16 {
  font-family: monospace;
  font-size: 11px;
}

.performancepg-inline-17 {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 16px;
}

.performancepg-dyn-1 {
  font-size: 14px;
  color: var(--performancepg-1-color);
}

.performancepg-dyn-2 {
  border-left: var(--performancepg-2-border-left);
}

.performancepg-dyn-3 {
  color: var(--performancepg-3-color);
}

.performancepg-dyn-4 {
  color: var(--performancepg-4-color);
}

.performancepg-dyn-5 {
  text-align: center;
  padding: 40px;
  color: var(--performancepg-5-color);
}

.performancepg-dyn-6 {
  width: 60px;
  height: 6px;
  background: var(--performancepg-6-background);
  border-radius: 6px;
  overflow: hidden;
}

.performancepg-dyn-7 {
  height: 100%;
  width: var(--performancepg-7-width);
  background: var(--performancepg-7-background);
  border-radius: 6px;
}

.performancepg-dyn-8 {
  font-size: 11px;
  font-weight: 700;
  color: var(--performancepg-8-color);
}

.performancepg-dyn-9 {
  background: var(--performancepg-9-background);
}

.performancepg-dyn-10 {
  font-size: 12px;
  color: var(--performancepg-10-color);
  margin: 8px 0;
}

.performancepg-dyn-11 {
  text-align: center;
  padding: 30px;
  color: var(--performancepg-11-color);
}

.performancepg-dyn-12 {
  font-weight: 600;
  color: var(--performancepg-12-color);
}

.performancepg-dyn-13 {
  font-weight: 700;
  color: var(--performancepg-13-color);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/HR/PerformancePg.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;AACtC","sourcesContent":[".performancepg-inline-1 {\n  text-align: center;\n  padding: 60px;\n}\n\n.performancepg-inline-2 {\n  margin: 0 auto 20px;\n}\n\n.performancepg-inline-3 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.performancepg-inline-4 {\n  margin-bottom: 16px;\n}\n\n.performancepg-inline-5 {\n  padding: 0;\n  overflow-x: auto;\n}\n\n.performancepg-inline-6 {\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.performancepg-inline-7 {\n  font-weight: 600;\n}\n\n.performancepg-inline-8 {\n  font-size: 11px;\n}\n\n.performancepg-inline-9 {\n  font-size: 11px;\n}\n\n.performancepg-inline-10 {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.performancepg-inline-11 {\n  font-size: 11px;\n}\n\n.performancepg-inline-12 {\n  display: flex;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n\n.performancepg-inline-13 {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  margin-top: 16px;\n}\n\n.performancepg-inline-14 {\n  overflow-x: auto;\n}\n\n.performancepg-inline-15 {\n  font-weight: 600;\n}\n\n.performancepg-inline-16 {\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.performancepg-inline-17 {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n  margin-top: 16px;\n}\n\n.performancepg-dyn-1 {\n  font-size: 14px;\n  color: var(--performancepg-1-color);\n}\n\n.performancepg-dyn-2 {\n  border-left: var(--performancepg-2-border-left);\n}\n\n.performancepg-dyn-3 {\n  color: var(--performancepg-3-color);\n}\n\n.performancepg-dyn-4 {\n  color: var(--performancepg-4-color);\n}\n\n.performancepg-dyn-5 {\n  text-align: center;\n  padding: 40px;\n  color: var(--performancepg-5-color);\n}\n\n.performancepg-dyn-6 {\n  width: 60px;\n  height: 6px;\n  background: var(--performancepg-6-background);\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.performancepg-dyn-7 {\n  height: 100%;\n  width: var(--performancepg-7-width);\n  background: var(--performancepg-7-background);\n  border-radius: 6px;\n}\n\n.performancepg-dyn-8 {\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--performancepg-8-color);\n}\n\n.performancepg-dyn-9 {\n  background: var(--performancepg-9-background);\n}\n\n.performancepg-dyn-10 {\n  font-size: 12px;\n  color: var(--performancepg-10-color);\n  margin: 8px 0;\n}\n\n.performancepg-dyn-11 {\n  text-align: center;\n  padding: 30px;\n  color: var(--performancepg-11-color);\n}\n\n.performancepg-dyn-12 {\n  font-weight: 600;\n  color: var(--performancepg-12-color);\n}\n\n.performancepg-dyn-13 {\n  font-weight: 700;\n  color: var(--performancepg-13-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
